var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#161616;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,3.3h-1.8V1.5c0-0.6-0.5-1-1-1h-13c-0.6,0-1,0.5-1,1v16.3c0,0.6,0.5,1,1,1h1.8v1.8c0,0.6,0.5,1,1,1h8.7 c0.6,0,1.4-0.3,1.8-0.7l2.9-2.7c0.4-0.4,0.7-1.2,0.7-1.7V4.3C20.2,3.7,19.7,3.3,19.1,3.3z M3.3,18.1C3.2,18.1,3,18,3,17.8V1.5 c0-0.1,0.1-0.3,0.3-0.3h13c0.1,0,0.3,0.1,0.3,0.3v1.8H6.1c-0.6,0-1,0.5-1,1v13.8H3.3z M6.1,20.9c-0.1,0-0.3-0.1-0.3-0.3V4.3 C5.9,4.2,6,4,6.1,4h13c0.1,0,0.3,0.1,0.3,0.3v12.2c0,0.1,0,0.2,0,0.3h-2.9c-0.8,0-1.4,0.6-1.4,1.4v2.6c-0.1,0-0.2,0-0.3,0H6.1V20.9 z M16,20.4c-0.1,0.1-0.1,0.1-0.2,0.2v-2.3c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2H19c0,0.1-0.1,0.1-0.1,0.1L16,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,7.6h7.4c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H8.9C8.7,6.8,8.6,7,8.6,7.2S8.7,7.6,8.9,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,12.7h7.4c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H8.9c-0.2,0-0.4,0.2-0.4,0.4C8.6,12.5,8.7,12.7,8.9,12.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,14.5H8.9c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4H13c0.2,0,0.4-0.2,0.4-0.4S13.2,14.5,13,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,10.2h7.4c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H8.9c-0.2,0-0.4,0.2-0.4,0.4C8.6,10,8.7,10.2,8.9,10.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.2683001a.svg";
export { ForwardRef as ReactComponent };